const DEFAULT_BILLING =
  "Billing is temporarily unavailable. Please try again in a moment.";

const STALE_CHECKOUT =
  "This checkout has expired. If you already paid, open your plan page to confirm — otherwise start checkout again.";

const SESSION_EXPIRED = "Your session expired. Please sign in again.";

/** @param {unknown} raw */
export function isStaleCheckoutSessionError(raw) {
  const msg = String(raw ?? "");
  return (
    /no such checkout\.session/i.test(msg) ||
    (/resource_missing/i.test(msg) && /checkout/i.test(msg))
  );
}

/** @param {string} msg */
function looksTechnical(msg) {
  const lower = msg.toLowerCase();
  return (
    lower.startsWith("http ") ||
    /^HTTP \d{3}$/.test(msg.trim()) ||
    lower.includes("appwrite") ||
    lower.includes("stripe:") ||
    lower.includes("no such customer") ||
    lower.includes("no such checkout") ||
    lower.includes("metadata mismatch") ||
    lower.includes("gateway returned") ||
    lower.includes("non-json response") ||
    /cs_(test|live)_[a-z0-9]+/i.test(msg) ||
    /\bcus_[a-z0-9]+\b/i.test(msg) ||
    /\bacct_[a-z0-9]+\b/i.test(msg) ||
    /\bwhsec_/i.test(msg) ||
    /\bsk_(test|live)_/i.test(msg)
  );
}

/**
 * Map gateway / Stripe / infrastructure errors to copy safe to show in the UI.
 * Preserves short, plain-language errors already returned by our billing handlers.
 *
 * @param {unknown} raw
 * @param {{ fallback?: string }} [opts]
 */
export function toUserFacingBillingError(raw, opts = {}) {
  const fallback = opts.fallback ?? DEFAULT_BILLING;
  const msg = String(raw ?? "").trim();
  if (!msg) return fallback;

  if (isStaleCheckoutSessionError(msg)) return STALE_CHECKOUT;

  const lower = msg.toLowerCase();
  if (lower.includes("http 503") || lower === "503") return fallback;
  if (lower.includes("http 502") || lower === "502") return fallback;
  if (lower.includes("http 500") || lower === "500") return fallback;
  if (lower.includes("unauthorized") || lower.includes("401")) return SESSION_EXPIRED;

  if (looksTechnical(msg)) return fallback;

  return msg;
}

export const billingErrorCopy = {
  defaultUnavailable: DEFAULT_BILLING,
  staleCheckout: STALE_CHECKOUT,
  sessionExpired: SESSION_EXPIRED,
  verifyClientPlan:
    "We couldn't confirm your plan. Please try again or go to billing to subscribe.",
  linkSubscription:
    "Payment succeeded — we're linking it to your account. This usually takes a few seconds.",
  couldNotLinkSubscription:
    "We couldn't link your subscription to this account. If payment went through, try again or contact support.",
};
